import { __assign, __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import ScrollableContent from '../../../ScrollableContent';
import Dropdown from '../../../Dropdown';
import DropdownMenu from '../../../Menu';
import CheckIcon from '../../../Icons/Check';
import { IconSize } from '../../../Icons/IconWrap';
import { isNullableDropdownGroup, convertNullableGroupToDropdownGroup, } from '../../types';
import BiLink from '../../../biLogger/Components/BiLink';
import BiSpan from '../../../biLogger/Components/BiSpan';
import StandardMenuSubmenu from './StandardMenuSubmenu';
import ArrowUp from '../../../Icons/ArrowUp';
import ArrowDown from '../../../Icons/ArrowDown';
import s from './StandardMenu.scss';
var StandardMenu = /** @class */ (function (_super) {
    __extends(StandardMenu, _super);
    function StandardMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.scrollableRef = null;
        _this.setScrollableRef = function (node) { return (_this.scrollableRef = node); };
        _this.renderItem = function (item, idx, hideCheckIcon) {
            var icon;
            if (item.icon) {
                icon = React.cloneElement(item.icon, {
                    className: classnames(s['menu-item-icon'], item.iconClassName),
                });
            }
            var _a = _this.getComponentClassAndProps(item), componentClass = _a.componentClass, componentProps = _a.componentProps;
            var key = item.value || "item_" + idx;
            return (React.createElement(Dropdown.MenuItem, { key: key, componentClass: componentClass, componentProps: componentProps, className: classnames(s['menu-item'], item.onClick && s['clickable'], item.disabled && s['disabled'], item.danger && s['danger'], _this.props.itemClassName, item.className), value: item.value, disabled: item.disabled, selected: item.selected, label: typeof item.label === 'string' ? item.label : undefined, onClick: item.onClick, biData: item.biData },
                icon,
                _this.renderItemLabel(item),
                item.selected && !hideCheckIcon && (React.createElement(CheckIcon, { className: s['selected-icon'], size: IconSize.TINY }))));
        };
        _this.onScrolled = function (scrollTop, distanceToBottom) {
            _this.setState({ scrollTop: scrollTop, distanceToBottom: distanceToBottom });
        };
        _this.onScrollClick = function (e, distance) {
            var scrollable = _this.props.scrollable;
            if (!scrollable || !_this.scrollableRef) {
                return;
            }
            _this.scrollableRef.scrollBy({ top: distance, behavior: 'smooth' });
            e.stopPropagation();
        };
        _this.onScrollUpClick = function (e) { return _this.onScrollClick(e, -200); };
        _this.onScrollDownClick = function (e) { return _this.onScrollClick(e, 200); };
        return _this;
    }
    StandardMenu.prototype.render = function () {
        var label = this.props.label;
        var _a = this.state, _b = _a.scrollTop, scrollTop = _b === void 0 ? 0 : _b, _c = _a.distanceToBottom, distanceToBottom = _c === void 0 ? 0 : _c;
        var scrollable = this.props.scrollable || label;
        var content = this.renderMenu();
        if (scrollable) {
            content = (React.createElement(ScrollableContent, { className: classnames('no-theme-skin', s['scrollable-content'], scrollTop === 0 && s['top'], distanceToBottom === 0 && s['bottom']), onScrolled: this.onScrolled, innerRef: this.setScrollableRef }, content));
        }
        return this.renderContent(content);
    };
    StandardMenu.prototype.renderContent = function (content) {
        var _a = this.props, label = _a.label, withCardWrapper = _a.withCardWrapper, withHoverEffect = _a.withHoverEffect, withPaddings = _a.withPaddings, withItemHorizontalPaddings = _a.withItemHorizontalPaddings, containerId = _a.containerId, containerRole = _a.containerRole, className = _a.className, labelClassName = _a.labelClassName;
        var _b = this.state.scrollTop, scrollTop = _b === void 0 ? 0 : _b;
        var hasPaddings = withPaddings && !label;
        var isLabelSticky = scrollTop > 0;
        return (React.createElement("div", { id: containerId, role: containerRole, className: classnames('no-theme-skin', s['root'], withHoverEffect && s['with-hover-effect'], withCardWrapper && s['with-card-wrapper'], hasPaddings && s['with-paddings'], !withItemHorizontalPaddings && s['without-item-horizontal-paddings'], // negative condition, so that the default selector is weaker and allows custom overrides
            className) }, label ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classnames(s['label'], isLabelSticky && s['sticky'], labelClassName) }, label),
            content)) : (content)));
    };
    StandardMenu.prototype.renderMenu = function () {
        var _this = this;
        var _a = this.props, items = _a.items, menuClassName = _a.menuClassName, onClose = _a.onClose, onSelect = _a.onSelect, lightText = _a.lightText, _b = _a.hideCheckIcon, hideCheckIcon = _b === void 0 ? false : _b, withScrollableArrows = _a.withScrollableArrows, _c = _a.withBottomPaddings, withBottomPaddings = _c === void 0 ? true : _c;
        return (React.createElement(Dropdown.Menu, { className: classnames(s['menu'], lightText && s['light-text'], !withBottomPaddings && s['without-bottom-padding'], menuClassName), onClose: onClose, onSelect: onSelect },
            items.map(function (item, idx) {
                if (!item) {
                    return null;
                }
                if (isNullableDropdownGroup(item)) {
                    var group = convertNullableGroupToDropdownGroup(item);
                    if (group) {
                        return _this.renderGroup(group, idx, hideCheckIcon);
                    }
                    return null;
                }
                return _this.renderItem(item, idx, hideCheckIcon);
            }),
            withScrollableArrows && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: s['scroll-arrow-up'], onClick: this.onScrollUpClick },
                    React.createElement("div", { className: s['scroll-arrow-clickable'] },
                        React.createElement(ArrowUp, { disableDefaultColors: true }))),
                React.createElement("div", { className: s['scroll-arrow-down'], onClick: this.onScrollDownClick },
                    React.createElement("div", { className: s['scroll-arrow-clickable'] },
                        React.createElement(ArrowDown, { disableDefaultColors: true })))))));
    };
    StandardMenu.prototype.getComponentClassAndProps = function (item) {
        var componentClass = item.componentClass ? item.componentClass : BiSpan;
        var componentProps = item.componentProps || {};
        if (item.link) {
            return {
                componentClass: item.componentClass || BiLink,
                componentProps: __assign(__assign({}, componentProps), { href: item.link, target: item.target, title: item.title }),
            };
        }
        if (item.submenu) {
            return {
                componentClass: StandardMenuSubmenu,
                componentProps: __assign(__assign({}, componentProps), { submenu: item.submenu }),
            };
        }
        return {
            componentClass: componentClass,
            componentProps: componentProps,
        };
    };
    StandardMenu.prototype.renderItemLabel = function (item) {
        // allows some items to separate visually their text label from option label
        if (item.complexLabel) {
            return item.complexLabel;
        }
        return typeof item.label === 'string' ? (React.createElement("span", { className: s['menu-item-text-label'] }, item.label)) : (item.label);
    };
    StandardMenu.prototype.renderGroup = function (group, idx, hideCheckIcon) {
        var _this = this;
        return (React.createElement(Dropdown.ItemGroup, { className: classnames(s['menu-group'], group.className, this.props.groupClassName), key: group.label || "group_" + idx, label: group.label, disabled: group.disabled }, group.items.map(function (item, sub_idx) {
            return _this.renderItem(item, sub_idx, hideCheckIcon);
        })));
    };
    StandardMenu.displayName = 'StandardMenu';
    StandardMenu.defaultProps = {
        componentType: DropdownMenu,
        withHoverEffect: true,
        withCardWrapper: true,
        withPaddings: true,
        withItemHorizontalPaddings: true,
        withBottomPaddings: true,
    };
    return StandardMenu;
}(React.PureComponent));
export { StandardMenu };
export default StandardMenu;
//# sourceMappingURL=StandardMenu.js.map